import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Confetti } from '@/components/animations/Confetti';
import { useLocaleOptional } from '@/contexts/LocaleContext';
import { PartyPopper } from 'lucide-react';

interface LanguageAnnouncementModalProps {
  open: boolean;
  onClose: () => void;
}

export const LanguageAnnouncementModal: React.FC<LanguageAnnouncementModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation();
  const localeContext = useLocaleOptional();
  const setLanguage = localeContext?.setLanguage;

  const handleYes = async () => {
    if (setLanguage) {
      await setLanguage('pt-BR');
    }
    onClose();
  };

  const handleNo = () => {
    onClose();
  };

  return (
    <>
      {open && <Confetti />}
      <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="p-4 rounded-full bg-primary/10">
                <PartyPopper className="h-12 w-12 text-primary" />
              </div>
            </div>
            <DialogTitle className="text-2xl text-center">
              🎉 {t('announcements.languageTitle')} 🎉
            </DialogTitle>
            <DialogDescription className="text-center text-base pt-4">
              {t('announcements.languageMessage')}
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col gap-3 mt-6">
            <Button
              onClick={handleYes}
              className="w-full bg-green-600 hover:bg-green-700 text-white"
              size="lg"
            >
              ✨ {t('announcements.yesChangeLanguage')} ✨
            </Button>
            <Button
              onClick={handleNo}
              variant="outline"
              className="w-full"
              size="lg"
            >
              {t('announcements.noKeepCurrent')}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
